var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c("div", { staticClass: "opt" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "QB",
                  expression: "'QB'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 10000 },
              on: {
                click: function ($event) {
                  return _vm.changeType(10000, "QB")
                },
              },
            },
            [_vm._v("全部(" + _vm._s(_vm.tabTotal || 0) + ")")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "WFS",
                  expression: "'WFS'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.changeType(1, "WFS")
                },
              },
            },
            [
              _vm._v(
                "未发送(" +
                  _vm._s(_vm.tabNumer.find((a) => a.type === 0)?.qty || 0) +
                  ")"
              ),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "YFS",
                  expression: "'YFS'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 2 },
              on: {
                click: function ($event) {
                  return _vm.changeType(2, "YFS")
                },
              },
            },
            [
              _vm._v(
                "已发送(" +
                  _vm._s(_vm.tabNumer.find((a) => a.type === 1)?.qty || 0) +
                  ")"
              ),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "QX",
                  expression: "'QX'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 3 },
              on: {
                click: function ($event) {
                  return _vm.changeType(3, "QX")
                },
              },
            },
            [
              _vm._v(
                "取消(" +
                  _vm._s(_vm.tabNumer.find((a) => a.type === 2)?.qty || 0) +
                  ")"
              ),
            ]
          ),
        ]),
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "el-popover",
                {
                  ref: "popover",
                  staticClass: "searchPop",
                  attrs: {
                    placement: "top",
                    title: "批量搜索",
                    trigger: "click",
                    width: "378",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "close",
                      on: { click: _vm.closeSearchPanel },
                    },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                  _c("base-muti-input", {
                    ref: "baseMutiInput",
                    model: {
                      value: _vm.referenceNumber,
                      callback: function ($$v) {
                        _vm.referenceNumber = $$v
                      },
                      expression: "referenceNumber",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        margin: "16px 0 0",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleEmpty },
                        },
                        [_vm._v("清空")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "sure",
                          on: { mousedown: _vm.handleConfirm },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-input", {
                staticClass: "input-search",
                attrs: {
                  value: _vm.searchVal,
                  placeholder: "请输入提单号/柜号/参考号搜索",
                },
                on: { focus: _vm.handleFocus },
              }),
              _c(
                "div",
                { staticClass: "btn-search", on: { click: _vm.handleConfirm } },
                [_c("i", { staticClass: "el-icon-search" })]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  loading: _vm.loading,
                  isPager: true,
                  isEmptyBorder: true,
                },
                on: {
                  sortChange: _vm.sortChange,
                  handlePageChange: _vm.handlePageChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("取消"),
                                            expression:
                                              "computedPermissions('取消')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("取消"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("发送"),
                                            expression:
                                              "computedPermissions('发送')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("发送"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.send(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("发送")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("附件"),
                                            expression:
                                              "computedPermissions('附件')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("附件"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewFile(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("附件")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("重发"),
                                            expression:
                                              "computedPermissions('重发')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("重发"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.send(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("重发")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "etdeta",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("ETD"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.etd)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("ATD"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.atd)),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "etaata",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("ETA"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.eta)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("ATA"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.ata)),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "port",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("始发港"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.originHarborName)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("卸货港"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.dischargeHarbor)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("目的港"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.destinationHarborName)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("船名/航次"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(row.scope.vesselName) +
                                  " / " +
                                  _vm._s(row.scope.voyageNo)
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2614707134
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("SendEmailDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
          ok: function ($event) {
            _vm.dialogVisible = false
            _vm.getList(_vm.pager)
          },
        },
      }),
      _c("ClearenceFileDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible1 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }